import React from 'react';
import { useResponsiveColumns } from '../../hooks/useResponsive';

interface ResponsiveGridProps {
    children: React.ReactNode;
    className?: string;
}

const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({ children, className = '' }) => {
    const columns = useResponsiveColumns();

    return (
        <div
            className={`responsive-products-grid ${className}`}
            style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gap: '1.5rem',
                marginBottom: '2rem'
            }}
        >
            {children}
        </div>
    );
};

export default ResponsiveGrid;